import { render, staticRenderFns } from "./SignalIndicatorRSI.vue?vue&type=template&id=66a7a92c&scoped=true&"
import script from "./SignalIndicatorRSI.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignalIndicatorRSI.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7a92c",
  null
  
)

export default component.exports